import { InstagramOutlined } from '@ant-design/icons';
import styled, { useTheme } from 'styled-components';
import Column from '../core/components/box/column';
import SizedBox from '../core/components/box/sizedBox';
import { device, useMedia } from '../core/designSystem/device';
import { LXbody, LXbodyLong, LXCaption } from '../core/texts/lxText';

const ResponsiveBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1040px;
  @media ${device.tabletAndBelow} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

interface FooterProps {}
const Footer = (props: FooterProps) => {
  const theme = useTheme();
  const { isDesktop } = useMedia();

  const InfoBox = ({
    title,
    contents,
  }: {
    title: string;
    contents: string;
  }) => {
    return (
      <Column width={isDesktop ? '512px' : '100%'}>
        <LXCaption>{title}</LXCaption>
        <LXbodyLong lineHeight="18px">{contents}</LXbodyLong>
      </Column>
    );
  };

  return (
    <Column
      padding="30px 25px"
      alignItems="center"
      backgroundColor={theme.colors.grayBgLight}
    >
      <SizedBox height={10} />
      <ResponsiveBox>
        <InfoBox
          title={theme.intro.location}
          contents={
            'PT. SLX Global Healthcare JI.Penjernihan | No. 48 RT.003 / RW.008, Bendungan Hilir, Tanah Abang, Jakarta Pusat 10210, Indonesia '
          }
        />
        <SizedBox height={24} width={16} />
        <InfoBox
          title={theme.intro.contact}
          contents={`${theme.texts.slxEmail}\n${theme.texts.slxPhone}`}
        />
        <SizedBox height={40} />
        <button
          disabled
          style={{
            backgroundColor: 'transparent',
            border: 'none',
          }}
        >
          <InstagramOutlined style={{ fontSize: '24px' }} />
        </button>
      </ResponsiveBox>
      <SizedBox height={isDesktop ? 60 : 40} />
      <div style={{ maxWidth: '1040px', width: '100%' }}>
        <LXbody color={theme.colors.caption}>
          {`© ${new Date().getFullYear()} ${theme.texts.allRightReserver}`}
        </LXbody>
      </div>
    </Column>
  );
};

export default Footer;
